











import { Component, Vue, Prop, Inject } from 'vue-property-decorator'

@Component
export default class PromotionOperate extends Vue {
  @Prop({ default: () => [] }) readonly operates!: Array<any> //操作坑位配置列表

  get operateArray() {
    if (this.operates.length > 4) {
      return this.operates.slice(0, 4)
    } else if (this.operates.length == 4) {
      return this.operates
    } else {
      return []
    }
  }

  @Inject({ from: 'operateEP', default: null }) operateEP!: any
  get operateExposure() {
    return this.operateEP && this.operateEP({})
  }
  linkTo(idx: number) {
    const count = this.operateArray.length
    if (idx < count) {
      this.$emit('operateClick',this.operateArray[idx])
      location.href = this.operateArray[idx].linkUrl
    }
  }
}
